import type { DismissBannerRequest, DismissedBannerCode, UserDetailsDTO } from '../index';
import { apiPost } from '../../api';
import { ApiNames, ApiPath } from '../../enums';

export function wasBannerDismissed({
  userDetails,
  bannerCode,
}: {
  userDetails: UserDetailsDTO;
  bannerCode: DismissedBannerCode;
}): boolean {
  return (
    userDetails.dismissedBanners && userDetails.dismissedBanners.some((banner) => banner.bannerCode === bannerCode)
  );
}

export async function dismissBanner({ bannerCode }: { bannerCode: DismissedBannerCode }): Promise<void> {
  await apiPost<unknown, DismissBannerRequest>(
    ApiNames.MonorepoApiEndpoint,
    ApiPath.UsersDismissBanner,
    { bannerCode },
    true
  );
}
